import * as React from 'react'

export function useMediaQuery(mediaQueryString) {
    const queryString = removeReservedMediaKeyWord(mediaQueryString)
    const query =  window.matchMedia(queryString)
    const [matches, setMatches] = React.useState(query.matches) // one-time, instantaneous check
    React.useEffect(() => {
      const listener = (e) => setMatches(e.matches)
      query.addEventListener('change', listener)
      return () => query.removeEventListener('change', listener)
    }, [query])
    return matches
  }
  function removeReservedMediaKeyWord(mediaQueryString) {
    return mediaQueryString.replace('@media', '').trim()
  }